import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10e07ae7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "Search_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "计划日期", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_5 = { class: "Search_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "单据类型", -1))
const _hoisted_7 = { class: "Search_item_content" }
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_search_x" }, null, -1))
const _hoisted_11 = { class: "content_total" }
const _hoisted_12 = { class: "content_list" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "content_list_item_top" }
const _hoisted_15 = { class: "content_list_item_top_left" }
const _hoisted_16 = { class: "content_list_item_top_right" }
const _hoisted_17 = {
  key: 0,
  class: "created"
}
const _hoisted_18 = {
  key: 1,
  class: "warning"
}
const _hoisted_19 = {
  key: 2,
  class: "green"
}
const _hoisted_20 = {
  key: 3,
  class: "info"
}
const _hoisted_21 = {
  key: 4,
  class: "info"
}
const _hoisted_22 = { class: "content_list_item_content" }
const _hoisted_23 = { class: "content_list_item_content_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "单据类型：", -1))
const _hoisted_25 = { class: "content_list_item_content_item_nr" }
const _hoisted_26 = { class: "content_list_item_content_item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转出仓库：", -1))
const _hoisted_28 = { class: "content_list_item_content_item_nr" }
const _hoisted_29 = { class: "content_list_item_content_item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转出仓管员：", -1))
const _hoisted_31 = { class: "content_list_item_content_item_nr" }
const _hoisted_32 = { class: "content_list_item_content_item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转入仓库：", -1))
const _hoisted_34 = { class: "content_list_item_content_item_nr" }
const _hoisted_35 = { class: "content_list_item_content_item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转入仓管员：", -1))
const _hoisted_37 = { class: "content_list_item_content_item_nr" }
const _hoisted_38 = { class: "content_list_item_content_item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划转出日期：", -1))
const _hoisted_40 = { class: "content_list_item_content_item_nr" }
const _hoisted_41 = { class: "content_list_item_content_item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划转入日期：", -1))
const _hoisted_43 = { class: "content_list_item_content_item_nr" }

import { reactive, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { gsdate } from "@/utils/utils";
// import { getList, pageCount } from "@/apis/PlanningAPI";
import { getTransferList, ZKPageCount } from "@/apis/materialStorage";
import { judgmentPlatform } from "@/utils/utils";
import { model } from '@/interface';
import vSearch from "@/components/common/Search.vue";
import vLableSelection from "@/components/common/LabelSelection.vue";

// 分页/查询-----接口
interface PagingType extends model {
  total: number;
  outPlanDateEnd: string; // 计划转出开始时间
  outPlanDateStart: string; // 计划转出结束时间
  code: string; // 转库单号
  status: string; // 状态
  type: string; // 状态
}

// 分页/查询-----数据

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const listData = reactive<PagingType>({
  capacity: 10,
  page: 0,
  total: 0,
  outPlanDateEnd: "",
  outPlanDateStart: "",
  code: "",
  type: "",
  status: "",
});

const router = useRouter();

const minDate: Date = new Date(new Date().getFullYear() - 1, 1, 1)

const maxDate: Date = new Date(new Date().getFullYear() + 1, 12, 30)

// 类型
let types: Array<{ name: string, id: string, isActive: boolean }> = reactive(
[
    // { name: '全部', id: '', isActive: false },
    // { name: '车间领料', id: '1', isActive: false },
    // { name: '车间备料', id: '2', isActive: false },
    // { name: '其他', id: '3', isActive: false },
    { name: '车间领料', id: '1', isActive: false },
    { name: '计划领料', id: '2', isActive: false },
    { name: '机台备料', id: '3', isActive: false },
    { name: '完工入库', id: '4', isActive: false },
    { name: '车间转库', id: '5', isActive: false },
    { name: '外协领料转库', id: '6', isActive: false },
    { name: '外协完工转库', id: '7', isActive: false },
    { name: '产品入库', id: '8', isActive: false },
    { name: '产品转库', id: '9', isActive: false },
    { name: '让步放行入库', id: '10', isActive: false },
    { name: '让步放行转库', id: '11', isActive: false },
    { name: '客返返修领料', id: '12', isActive: false },
    { name: '客返返修入库', id: '13', isActive: false },
    { name: '跨组织转库', id: '14', isActive: false },
    { name: '工序报废', id: '15', isActive: false },
    { name: '客退返修领料', id: '16', isActive: false },
    { name: '客退返修入库', id: '17', isActive: false },
    { name: '废品入库', id: '30', isActive: false }
  ]
)

// 列表数据
let lists: any = ref([]);

// 控制打开日历插件
const isOpenDate = ref<boolean>(false);

// 根据平台是否需要设置top
let status = ref<boolean>(false);

const loading = ref<boolean>(false);
const finished = ref<boolean>(false);
const refreshing = ref(false)

const orderType = reactive<Array<{name: string; id: Number;}>>([
        { name: '车间领料', id: 1 },
        { name: '计划领料', id: 2 },
        { name: '机台备料', id: 3 },
        { name: '完工入库', id: 4 },
        { name: '车间转库', id: 5 },
        { name: '外协领料转库', id: 6 },
        { name: '外协完工转库', id: 7 },
        { name: '产品入库', id: 8 },
        { name: '产品转库', id: 9 },
        { name: '让步放行入库', id: 10 },
        { name: '让步放行转库', id: 11 },
        { name: '客返返修领料', id: 12 },
        { name: '客返返修入库', id: 13 },
        { name: '跨组织转库', id: 14 },
        { name: '工序报废', id: 15 },
        { name: '客退返修领料', id: 16 },
        { name: '客退返修入库', id: 17 },
        { name: '废品入库', id: 30 }
      ]);

// 搜索标签数据 0已计划、1已转出、2已转入、3已取消
const tagList = reactive<Array<{ id: string; name: string; num: string }>>([
  {
    id: "",
    name: "全部",
    num: "10",
  },
  {
    id: "0",
    name: "已计划",
    num: "132",
  },
  {
    id: "1",
    name: "已转出",
    num: "3",
  },
  {
    id: "2",
    name: "已转入",
    num: "12",
  },
  {
    id: "3",
    name: "已取消",
    num: "12",
  },
]);

const reset = () => {
  listData.code = '';
  listData.page = 0;
  finished.value = false;
  lists.value = [];
  listData.type = ''
  listData.outPlanDateEnd = ''
  listData.outPlanDateStart = ''
  types.forEach((item: {name: string, id: string, isActive: boolean }) => {
    item.isActive = false
  })
  getLists();
  getZKPageCount()
}

// 统计总数
const getZKPageCount = () => {
  ZKPageCount({
    code: listData.code,
    outPlanDateEnd: listData.outPlanDateEnd,
    outPlanDateStart: listData.outPlanDateStart,
    type: listData.type
  })
    .then(res => {
      if (res.code === 200) {
        tagList[0].num = res.data.allNum
        tagList[1].num = res.data.startNum
        tagList[2].num = res.data.outNum
        tagList[3].num = res.data.inNum
        tagList[4].num = res.data.cancelNum
      }
    })
}

onMounted(() => {
  getZKPageCount()
  status.value = judgmentPlatform();
  listData.page = 0
});

const clickTag = (val: string) => {
  console.log(val)
  listData.status = val
  listData.page = 0;
  finished.value = false;
  lists.value = [];
  getLists()
}

// 获取列表统计
// const pageCounts = () => {
//   pageCount({}).then((res) => {
//     if (res.code === 200 && res.data) {
//       tagList[0].num = res.data.allNum;
//       tagList[1].num = res.data.startNum;
//       tagList[2].num = res.data.ingNum;
//       tagList[3].num = res.data.endNum;
//     }
//   });
// };

const tyepToStr = (type: number): string => {
  //  <!-- 1、车间领料；2、车间备料；3、其他；4、完工入库 -->
  for (const item of orderType) {
    if (item.id == type) {
      return item.name
    }
  }
  return '-'
}

const loadData = (): void => {
  getLists()
}

// 获取计划列表数据
const getLists = (): void => {
  if (!finished.value) {
    loading.value = true;
    listData.page = listData.page + 1;
    getTransferList({
      capacity: listData.capacity,
      model: {
        code: listData.code,
        outPlanDateEnd: listData.outPlanDateEnd,
        outPlanDateStart: listData.outPlanDateStart,
        type: listData.type,
        status: listData.status,
      },
      page: listData.page,
      sorts: [
        {
          direction: "ASC",
          property: "publishDate",
        },
      ],
    })
      .then((res: any) => {
        if (refreshing.value) {
          lists.value = []
          refreshing.value = false;
        }
        loading.value = false;
        listData.total = res.data.total;
        if (res.code === 200) {
          if (res.data.records.length < listData.capacity) {
            finished.value = true;
          }
          if (listData.page === 1) {
            lists.value = res.data.records;
          } else {
            lists.value.push(...res.data.records);
          }
        }
      })
      .catch((err: any) => {
        loading.value = false;
        finished.value = true;
        if (refreshing.value) {
          lists.value = []
          refreshing.value = false;
        }
      })
  }
};

// 下拉刷新优化页面
const onRefresh = () => {
  finished.value = false;
  listData.page = 0
  loading.value = true;
  getLists();
}

// 接收子组件传来的输入框值
const searchInput = (val: string): void => {
  listData.code = val;
  listData.page = 0;
  finished.value = false;
  lists.value = [];
  getLists();
  getZKPageCount()
}

// 搜索弹框提交
const submit = (): void => {
  listData.page = 0;
  finished.value = false;
  lists.value = [];
  getLists();
  getZKPageCount()
};

// 打开日期插件
const openDate = (): void => {
  isOpenDate.value = true;
};

// 确认选择时间
const onConfirm = (values: any): void => {
  const [start, end] = values;
  listData.outPlanDateStart = gsdate(start);
  listData.outPlanDateEnd = gsdate(end);
  isOpenDate.value = false;
};

// 切换工序
const changeTag = (i: any): void => {
  types[i].isActive = !types[i].isActive;
  listData.type = types[i].id
  for (const index in types) {
    if (index != i) {
      console.log(index, i)
      const item = types[index]
      item.isActive = false
    }
  }
};



// 跳转详情
const jump = (item: any): void => {
  router.push({ name: "wTransferDetail", query: { id: item.id } });
};

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ content_top: _unref(status) }, "content_search"])
    }, [
      _createVNode(vSearch, {
        ref: "Search",
        onSearchInput: searchInput,
        onSubmit: submit,
        onReset: reset,
        isShow: true,
        placeholder: "搜索转库单号"
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "Search_item_content",
              onClick: openDate
            }, [
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(listData).outPlanDateStart ? 'color: #000' : '')
              }, _toDisplayString(_unref(listData).outPlanDateStart ? _unref(listData).outPlanDateStart : "开始日期"), 5),
              _hoisted_4,
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(listData).outPlanDateEnd ? 'color: #000' : '')
              }, _toDisplayString(_unref(listData).outPlanDateEnd ? _unref(listData).outPlanDateEnd : "结束日期"), 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(types), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", { tag_active: item.isActive }]),
                    key: item.id,
                    onClick: ($event: any) => (changeTag(i))
                  }, _toDisplayString(item.name), 11, _hoisted_9))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }, 512),
      _hoisted_10,
      _createVNode(vLableSelection, {
        TagList: _unref(tagList),
        isShow: true,
        onChange: clickTag
      }, null, 8, ["TagList"])
    ], 2),
    _createElementVNode("div", _hoisted_11, "共" + _toDisplayString(_unref(listData).total) + "条数据", 1),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: loadData
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lists), (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content_list_item",
                  key: i,
                  onClick: ($event: any) => (jump(item))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", null, _toDisplayString(item.code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      (item.status === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "待出库"))
                        : (item.status === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, "已出库"))
                          : (item.status === 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "已入库"))
                            : (item.status === 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "已取消"))
                              : (item.status === 4)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "已退回"))
                                : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, _toDisplayString(tyepToStr(item.type)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, _toDisplayString(item.outWarehouseName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, _toDisplayString(item.outUserName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, _toDisplayString(item.inWarehouseName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, _toDisplayString(item.inUserName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, _toDisplayString(item.outPlandate), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, _toDisplayString(item.inPlandate), 1)
                    ])
                  ])
                ], 8, _hoisted_13))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_calendar, {
      show: isOpenDate.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isOpenDate).value = $event)),
      type: "range",
      "min-date": _unref(minDate),
      "max-date": _unref(maxDate),
      onConfirm: onConfirm,
      color: "#4275FC"
    }, null, 8, ["show", "min-date", "max-date"])
  ]))
}
}

})